import { useTranslation } from "react-i18next";
import FadeInSection from "@/components/base/FadeInSection";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex flex-col items-center justify-center bg-foreground-950 px-4 md:px-6 pt-24 md:pt-32 pb-16 md:pb-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20organic%20shapes%20in%20warm%20amber%20gold%20cream%20and%20soft%20sage%20green%20tones%20blending%20together%20on%20dark%20charcoal%20background%2C%20elegant%20minimalist%20gradient%20art%2C%20smooth%20curves%20and%20gentle%20transitions%2C%20sophisticated%20contemporary%20aesthetic%2C%20no%20text%20no%20logos%20no%20objects%2C%20serene%20atmospheric%20composition&width=1600&height=900&seq=hero-bg-v2-main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/30 to-foreground-950/70"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto flex flex-col items-center text-center">
        <FadeInSection delay={0}>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-sm text-white/80 text-xs md:text-sm font-medium mb-6 md:mb-8 border border-white/10">
            <i className="ri-sparkling-line w-4 h-4 flex items-center justify-center"></i>
            <span>USFansSpreadsheet – Kompletny przewodnik</span>
          </div>
        </FadeInSection>

        <FadeInSection delay={100}>
          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold text-white leading-tight mb-4 md:mb-6 max-w-3xl">
            USFansSpreadsheet<br className="hidden sm:block" />
            2026 – Porównania i Przewodnik
          </h1>
        </FadeInSection>

        <FadeInSection delay={200}>
          <p className="text-sm md:text-base text-white/60 max-w-xl mb-8 md:mb-10 leading-relaxed">
            {t("hero.subtitle")}
          </p>
        </FadeInSection>

        <FadeInSection delay={300}>
          <ul className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 md:gap-4 mb-8 md:mb-10 text-xs md:text-sm text-white/70">
            <li className="flex items-center gap-2">
              <span className="w-5 h-5 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-xs text-white"></i>
              </span>
              {t("hero.check_1")}
            </li>
            <li className="flex items-center gap-2">
              <span className="w-5 h-5 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-xs text-white"></i>
              </span>
              {t("hero.check_2")}
            </li>
            <li className="flex items-center gap-2">
              <span className="w-5 h-5 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-xs text-white"></i>
              </span>
              {t("hero.check_3")}
            </li>
            <li className="flex items-center gap-2">
              <span className="w-5 h-5 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-xs text-white"></i>
              </span>
              {t("hero.check_4")}
            </li>
          </ul>
        </FadeInSection>

        <FadeInSection delay={400}>
          <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-3.5 bg-white text-foreground-950 rounded-full text-sm md:text-base font-medium hover:bg-white/90 transition-colors"
            >
              {t("hero.btn_usfans")}
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-3.5 border-2 border-white/30 text-white rounded-full text-sm md:text-base font-medium hover:border-white/60 hover:bg-white/10 transition-colors"
            >
              {t("hero.btn_buy")}
              <i className="ri-shopping-bag-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}